import React from 'react'
import './policy.css'
import useDocumentTitle from '../useDocumentTitle.js';

export default function CancellationAndRefund() {
  window.scrollTo(0, 0);
  useDocumentTitle("Cancellation & Refund Policy")

  return (
    <div className='policy'>  
      <div>
        <h1>Cancellation and Refund Policy</h1>
        <p>Last updated: 10 January 2026</p>
      </div>

      <p>
        Thank you for choosing Vrajpath Itech LLP, a software service-based company providing digital solutions, SaaS products, and technology services.
      </p>

      <p>
        This Cancellation and Refund Policy outlines the terms under which cancellations and refunds may be processed for services purchased through our platform.
      </p>

      <h2>Interpretation and Definitions</h2>

      <h3>Definitions</h3>
      <ul>
        <li>
          <p><strong>Company</strong> refers to Vrajpath Itech LLP, Address - Eccosphere Coworking, Block B, Sector-67, Noida, Uttar Pradesh 201309, India</p>
        </li>
        <li>
          <p><strong>Services</strong> refer to software development, SaaS products, subscriptions, digital tools, and related offerings provided by the Company.</p>
        </li>
        <li>
          <p><strong>Order</strong> means a request by You to purchase or subscribe to Services.</p>
        </li>
        <li>
          <p><strong>Website</strong> refers to <a href="https://www.vrajpath.com" target="_blank" rel="noopener noreferrer">https://www.vrajpath.com</a></p>
        </li>
        <li>
          <p><strong>You</strong> means the individual or entity using the Service.</p>
        </li>
      </ul>

      <h2>Cancellation Policy</h2>

      <p>
        You may request cancellation of a service or subscription before the commencement of service delivery or activation.
      </p>

      <ul>
        <li>For subscription-based services, cancellation must be requested before the next billing cycle.</li>
        <li>For custom software or development services, cancellation requests will be evaluated based on the work completed.</li>
      </ul>

      <p>
        To request a cancellation, please contact us through:
      </p>

      <ul>
        <li>Email: support@vrajpath.com</li>
        <li>Website: <a href="https://www.vrajpath.com" target="_blank" rel="noopener noreferrer">https://www.vrajpath.com</a></li>
        <li>Phone: +91-9818527999</li>
      </ul>

      <h2>Refund Policy</h2>

      <p>
        Refunds are applicable only under the following conditions:
      </p>

      <ul>
        <li>Duplicate or accidental payment</li>
        <li>Service not delivered as agreed</li>
        <li>Technical issues preventing service usage (validated by our team)</li>
      </ul>

      <p>
        Refunds are not applicable in the following cases:
      </p>

      <ul>
        <li>Activated subscriptions or partially used services</li>
        <li>Custom software development once work has started</li>
        <li>Advertisement, booster, or promotional services</li>
      </ul>

      <h2>Refund Processing</h2>

      <p>
        Approved refunds will be processed within <strong>7–10 business days</strong> and will be credited to the original payment method.
      </p>

      <h2>Service-Based Conditions</h2>

      <ul>
        <li>All services are provided on a best-effort basis.</li>
        <li>Delivery timelines may vary based on project scope and requirements.</li>
        <li>Any disputes regarding service delivery will be resolved through mutual discussion.</li>
      </ul>

      <h2>Contact Us</h2>

      <p>
        If you have any questions about our Cancellation and Refund Policy, please contact us:
      </p>

      <ul>
        <li>Email: support@vrajpath.com</li>
        <li>Website: <a href="https://www.vrajpath.com" target="_blank" rel="noopener noreferrer">https://www.vrajpath.com</a></li>
        <li>Phone: +91-9818527999</li>
      </ul>
    </div>
  )
}